export default function isMOV(url) {
  if (typeof url !== "string") return;

  const urlArr = url.split(".");
  return urlArr[urlArr.length - 1].toLowerCase() === "mov";
}
